<template>
  <div class="clinical-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $tc('global.request', 2) }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="clinicalShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'ClinicalHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            clinicalShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.clinicalGridTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.newRequest'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'N' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.newRequest')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.clinicalPatientGridTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.newPatientRequest'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'N' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.newRequest')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.clinicalFormTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.newRequest'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'N' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.newRequest')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.saveRequest'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'S' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.saveRequest')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.formalizeRequest'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.formalizeRequest')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.discardRequestDraft'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: this.$t('component.shortcutsModal.delKey') }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.discardRequestDraft')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.formalizeAndPrintRequest'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'P' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.formalizeAndPrintRequest')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.nextSample'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-right', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextSample')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.previousSample'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-left', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.previousSample')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
